<template>
  <div id="app">
    <!-- <van-nav-bar
      title="My App"
      left-text="返回"
      right-text="登录"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    /> -->
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
      <van-tabbar-item icon="search" to="/about">关于</van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/products">产品</van-tabbar-item>
      <van-tabbar-item icon="setting-o" to="/contact">联系</van-tabbar-item>
    </van-tabbar> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // active: 0
    };
  },
  methods: {
    // onClickLeft() {
    //   this.$router.back()
    // },
    // onClickRight() {
    //   this.$router.push('/login')
    // }
  },
};
</script>
<style lang="scss" >
#app {
  // background: #4286F4;
}
</style>